import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { ErrorMessage } from 'formik';
import memoize from 'memoize-one';
import s from './FileUploadInput.module.scss';
import InfoBubble from '../InfoBubble/InfoBubble';
import InputErrorMessage from './InputErrorMessage';
import xIcon from '../../assets/icons/x.svg';
import { getFileFormatsMessageFromAllowedExtensions } from '../../containers/ContactPage/FormValidation/ValidationSchema';

class FileUploadInput extends React.Component {
  convertAllowedExtensions = memoize((allowedExtensions, intl) => {
    const accept = allowedExtensions.join(',');
    const fileFormats = getFileFormatsMessageFromAllowedExtensions(
      allowedExtensions,
      intl
    );
    return {
      accept,
      fileFormats,
    };
  });

  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.inputRef = null;
  }

  handleChange(event) {
    const { form, field } = this.props;
    const { name } = field;
    form.setFieldValue(name, event.currentTarget.files[0]);
  }

  handleClear(event) {
    event.stopPropagation();
    event.preventDefault();
    const { form, field } = this.props;
    const { name } = field;
    this.inputRef.value = '';
    form.setFieldValue(name, null);
  }

  handleButtonClick() {
    this.inputRef.click();
  }

  render() {
    const { field, allowedExtensions, ariaDescribedBy, intl } = this.props;

    let accept;
    let fileFormats;
    if (allowedExtensions) {
      ({ accept, fileFormats } = this.convertAllowedExtensions(
        allowedExtensions,
        intl
      ));
    }

    const { name, value } = field;

    const currentFileNameLabel = 'currentFileNameLabel';
    const addAFileLabel = 'addAFileLabel';

    /* eslint-disable jsx-a11y/click-events-have-key-events */
    /* eslint-disable jsx-a11y/no-static-element-interactions */
    /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
    return (
      <div className={s.fileInputLabelWrapper}>
        <div className={s.wrapper}>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <div id={addAFileLabel}>
            <FormattedMessage id="offerWizard.fileUpload.addFile" />
          </div>
          <div className={s.fileInputWrapper}>
            <input
              ref={(ref) => {
                this.inputRef = ref;
              }}
              className={s.fileInput}
              id={name}
              name={name}
              type="file"
              onChange={this.handleChange}
              multiple={false}
              accept={accept}
            />
            <div className={s.fileInputWidget}>
              <div className={s.fileInputAreaAndButton}>
                <div className={s.file}>
                  <div className={s.fileName}>
                    <div title={value && value.name} id={currentFileNameLabel}>
                      {value && value.name}
                    </div>
                  </div>
                  {!!value && (
                    <div>
                      <button
                        className={s.clearButton}
                        type="button"
                        onClick={this.handleClear}
                        aria-describedby={currentFileNameLabel}
                      >
                        <div className={s.clearIconWrapper}>
                          <img
                            src={xIcon}
                            alt={intl.formatMessage({
                              id: 'offerWizard.fileUpload.removeFile',
                            })}
                          />
                        </div>
                      </button>
                    </div>
                  )}
                </div>
                <button
                  className={s.chooseFileButton}
                  type="button"
                  onClick={this.handleButtonClick}
                  aria-describedby={`${ariaDescribedBy ?? ''} ${addAFileLabel}`}
                >
                  <div>
                    <FormattedMessage id="offerWizard.fileUpload.chooseFile" />
                  </div>
                </button>
              </div>
              <div className={s.infoBubbleWrapper}>
                <InfoBubble>
                  <FormattedMessage
                    id="offerWizard.fileUpload.info1"
                    values={{ fileFormats }}
                  />
                  <br />
                  <FormattedMessage id="offerWizard.fileUpload.info2" />
                </InfoBubble>
              </div>
            </div>
          </div>
          <ErrorMessage name={name} component={InputErrorMessage} />
        </div>
      </div>
    );
  }
}

FileUploadInput.defaultProps = {
  allowedExtensions: null,
  ariaDescribedBy: null,
};

FileUploadInput.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.shape({
      name: PropTypes.string,
    }),
    required: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
  }).isRequired,
  form: PropTypes.shape({
    setFieldValue: PropTypes.func.isRequired,
  }).isRequired,
  allowedExtensions: PropTypes.arrayOf(PropTypes.string),
  ariaDescribedBy: PropTypes.string,
  intl: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default injectIntl(FileUploadInput);
